import React, { useState } from 'react';

import Icon from 'views/site/Icon.js';

import Theme from 'styles/Theme.js';

/*
 * Button
 *
 * The marketing surface's button, ported from the storefront. Deliberately
 * separate from views/Button.js, which every legacy panel uses and which takes
 * an entirely different set of props (color / type: 'large' / utils). The two
 * cannot be reconciled without touching every legacy view, so they coexist —
 * this one lives under views/site with the rest of the marketing components.
 *
 * `primary` fills with the dealership's color as authored, taking whichever
 * foreground reads on it. See styles/Brand.js.
 */

const Button = ({ disabled, icon, label, loading, onClick, style, type = 'primary' }) => {

    const [hover, setHover] = useState(false);

    const getButtonStyle = () => {
        switch(type) {
            case 'secondary':
            return Theme.styles.button.secondary();

            case 'outline':
            return Theme.styles.button.outline();

            case 'primary':
            default:
            return Theme.styles.button.primary();
        }
    }

    const getHoverStyle = () => {
        if(disabled || loading || hover === false) {
            return {};
        }
        return {
            // boxShadow.button is a function here rather than the storefront's
            // constant, because the glow is tinted with the dealership accent
            boxShadow: type === 'primary' ? Theme.boxShadow.button() : Theme.boxShadow.cardHover,
            transform: 'translateY(-2px)'
        };
    }

    return (
        <button
        onClick={disabled || loading ? null : onClick}
        onMouseEnter={setHover.bind(this, true)}
        onMouseLeave={setHover.bind(this, false)}
        style={{
            ...getButtonStyle(),
            ...getHoverStyle(),
            cursor: disabled || loading ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            ...style
        }}>
            {loading && (
                <Icon
                className={'site-spin'}
                name={'arrow-repeat'}
                size={14}
                style={{ marginRight: 8 }} />
            )}
            {icon && !loading && (
                <Icon name={icon} size={14} />
            )}
            {label}
        </button>
    )
}

export default Button;
